export type TemplateTiming = "immediate" | "scheduled";

export interface SmsTemplate {
  id: string;
  name: string;
  text: string;
  timing: TemplateTiming;
  hoursBefore: number;
  isDefault: boolean;
  isMeetingTemplate: boolean;
}

// Placeholders replaced with calendar event data at send time.
export const PLACEHOLDERS = [
  "{Title}",
  "{Body}",
  "{Date}",
  "{Time}",
  "{Location}",
  "{Participants}",
] as const;

export function createEmptyTemplate(isMeeting = true): SmsTemplate {
  return {
    id: crypto.randomUUID ? crypto.randomUUID() : String(Date.now()),
    name: "",
    text: "",
    timing: "immediate",
    hoursBefore: 1,
    isDefault: false,
    isMeetingTemplate: isMeeting,
  };
}
